<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="row">
      <div class="col-xl-4 col-lg-5 col-12">
        <div class="card mb-6">
          <div class="card-body">
            <h5 class="card-title">{{ $t("maps.map_filters") }}</h5>
            <div class="mb-3">
              <label for="accounts_filter" class="form-label">{{
                $t("maps.accounts")
              }}</label>
              <select
                @change="applyFilter"
                v-model="filters.accounts"
                class="form-select"
                id="accounts_filter"
              >
                <option value="all">{{ $t("maps.all") }}</option>
                <option value="online">{{ $t("maps.online") }}</option>
                <option value="none">{{ $t("maps.none") }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="devices_filter" class="form-label">{{
                $t("maps.network_devices")
              }}</label>
              <select
                @change="applyFilter"
                v-model="filters.devices"
                class="form-select"
                id="devices_filter"
              >
                <option value="all">{{ $t("maps.all") }}</option>
                <option value="none">{{ $t("maps.none") }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="markers_filter" class="form-label">{{
                $t("maps.markers")
              }}</label>
              <select
                @change="applyFilter"
                v-model="filters.markers"
                class="form-select"
                id="markers_filter"
              >
                <option value="all">{{ $t("maps.all") }}</option>
                <option value="none">{{ $t("maps.none") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="card mb-6" v-if="hasPrivilege('map_add_marker_map')">
          <div class="card-body">
            <div v-if="!add_marker" class="d-grid w-100 mt-4 mb-4">
              <button
                class="btn btn-primary"
                @click="add_marker = true"
                :class="{
                  disabled_ssr: !this.$store.getters.settings.license.active,
                }"
              >
                <i class="ti ti-plus ti-xs me-2"></i>
                <span>{{ $t("maps.add_marker") }}</span>
              </button>
            </div>
            <div v-if="add_marker" class="mb-3">
              <label for="lat" class="form-label">{{ $t("maps.label") }}</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="new_marker.label.text"
              />
            </div>
            <div v-if="add_marker" class="mb-3">
              <label for="lng" class="form-label">{{ $t("maps.color") }}</label>
              <input
                type="color"
                class="form-control"
                id="lng"
                v-model="new_marker.icon.fillColor"
              />
            </div>
            <div v-if="add_marker">
              ({{ $t("maps.click_on_map_to_add_marker") }})
            </div>
            <div v-if="add_marker" class="d-grid w-100 mt-4 mb-4">
              <button class="btn btn-danger" @click="add_marker = false">
                <span>{{ $t("control.cancel") }}</span>
              </button>
            </div>
          </div>
        </div>
        <div v-if="selected_marker" class="card mb-6">
          <div class="card-body">
            <div class="mb-3">
              <label for="label" class="form-label">{{
                $t("maps.label")
              }}</label>
              <input
                type="text"
                class="form-control"
                id="label"
                v-model="selected_marker.name"
              />
            </div>
            <div class="mb-3">
              <label for="color" class="form-label">{{
                $t("maps.color")
              }}</label>
              <input
                type="color"
                class="form-control"
                id="color"
                v-model="selected_marker.color"
              />
            </div>
            <div class="row">
              <div class="col-6 d-flex justify-content-center">
                <div
                  class="btn btn-success"
                  @click="updateMarker(selected_marker)"
                >
                  {{ $t("control.save") }}
                </div>
              </div>
              <div class="col-6 d-flex justify-content-center">
                <div
                  class="btn btn-danger"
                  @click="deleteMarker(selected_marker)"
                >
                  {{ $t("control.delete") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7 col-12">
        <div class="card  mb-6">
          <div class="card-body">
            <div class="card-body" style="height: 580px;">
              <l-map
                ref="map"
                v-model:zoom="zoom"
                :center="[35.12675477961526, 38.65058859053918]"
                @click="onMapClick"
              >
                <l-tile-layer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  layer-type="base"
                  name="OpenStreetMap"
                ></l-tile-layer>

                <l-marker
                  v-for="account in accounts"
                  :key="account.id"
                  :lat-lng="[account.latitude, account.longitude]"
                  @click="$router.push(`/accounts/${account.id}`)"
                  :icon="account.icon"
                >
                </l-marker>
                <l-marker
                  v-for="device in network_devices"
                  :key="device.id"
                  :lat-lng="[device.latitude, device.longitude]"
                >
                  <l-tooltip>
                    <div>
                      {{ device.name + " | " + device.ip_address }}
                    </div>
                  </l-tooltip>
                  <l-icon
                    :icon-url="require(`@/assets/img/map/${device.type}.png`)"
                    :icon-size="[32, 32]"
                  ></l-icon>
                </l-marker>
                <l-marker
                  v-for="marker in markers"
                  :key="marker.id"
                  :lat-lng="[marker.latitude, marker.longitude]"
                  @click="selected_marker = marker"
                  :icon="marker.icon"
                >
                </l-marker>
              </l-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { hasPrivilege } from "../global_constants";
import { mapGetters } from "vuex";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      lat: 35.8636109,
      lng: 36.7950499,
      markers: [],
      original_markers: [],
      accounts: [],
      original_accounts: [],
      network_devices: [],
      original_network_devices: [],
      add_marker: false,
      selected_marker: null,
      zoom: 7,
      customIcon: L.divIcon({
        className: "custom-marker",
        html: `
    <div style="text-align:center;">
      <div style="font-size:12px; color:#333;">My Title</div>
      <div style="width:20px; height:20px; background:black; border-radius:50%; margin:auto;"></div>
    </div>
  `,
        iconSize: [30, 40],
        iconAnchor: [15, 40],
      }),
      new_marker: {
        lat: 0,
        lng: 0,
        icon: {
          path:
            "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z", // Default pin shape
          fillColor: "#0000ff", // Marker color
          fillOpacity: 1,
          strokeColor: "black", // Border color
          strokeWeight: 1,
          scale: 1, // Size of the marker
        },
        label: {
          text: "My location",
          color: "white",
          fontSize: "16px",
          fontWeight: "bold",
        },
      },
      icon_user_green: {
        path: "M 0,0 m -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0", // Custom circle path
        fillColor: "#00ff00",
        fillOpacity: 1,
        strokeColor: "black",
        strokeWeight: 1,
        scale: 1,
        url: require("@/assets/img/map/green.svg"),
      },
      icon_user_red: {
        path: "M 0,0 m -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0", // Custom circle path
        fillColor: "#ff0000",
        fillOpacity: 1,
        strokeColor: "black",
        strokeWeight: 1,
        scale: 1,
        url: require("@/assets/img/map/red.svg"),
      },
      icon_user_black: {
        path: "M 0,0 m -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0", // Custom circle path
        fillColor: "#ff0000",
        fillOpacity: 1,
        strokeColor: "black",
        strokeWeight: 1,
        scale: 1,
        url: require("@/assets/img/map/black.svg"),
      },
      icon_user_gray: {
        path: "M 0,0 m -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0", // Custom circle path
        fillColor: "#808080",
        fillOpacity: 1,
        strokeColor: "black",
        strokeWeight: 1,
        scale: 1,
        url: require("@/assets/img/map/gray.svg"),
      },
      icon_user: {
        url: require("@/assets/img/map/1.svg"),
        scaledSize: { width: 60, height: 60 },
      },
      filters: {
        accounts: "all",
        markers: "all",
        devices: "all",
      },
      loading: false,
    };
  },
  async created() {
    await this.getAccounts();
    await this.getMarkers();
    await this.getNetworkDevices();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async onMapClick(event) {
      if (!this.add_marker) return;
      this.add_marker = false;
      const latLng = event.latlng;
      this.new_marker.latitude = latLng.lat;
      this.new_marker.longitude = latLng.lng;
      this.new_marker.color = this.new_marker.icon.fillColor;
      this.new_marker.name = this.new_marker.label.text;
      this.new_marker.icon = "default_pin";
      await this.storeMarker(this.new_marker);
      this.new_marker.icon = L.divIcon({
        className: "custom-marker",
        html: `
            <div style="text-align:center;display: flex;flex-direction: column; align-items: center; justify-content: end;">
              <div style="font-size:12px; color:#333;width:65px;">${this.new_marker.name}</div>
              <div style="width:20px; height:20px; background:${this.new_marker.color}; border-radius:50%;"></div>
            </div>
          `,
        iconSize: [30, 40],
        iconAnchor: [15, 40],
      });
      this.markers.push(this.new_marker);
      this.new_marker = {
        lat: 0,
        lng: 0,
        icon: {
          path:
            "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z", // Default pin shape
          fillColor: "#0000ff", // Marker color
          fillOpacity: 1,
          strokeColor: "black", // Border color
          strokeWeight: 1,
          scale: 1, // Size of the marker
        },
        label: {
          text: "My location",
          color: "black",
          fontSize: "16px",
          fontWeight: "bold",
        },
      };
    },
    async storeMarker(marker) {
      const response = await axios.post("map/marker", marker);
      if (response.status === 200) {
        this.$notify({
          text: this.$t("maps.marker_added_successfully"),
          type: "success",
        });
        marker.id = response.data.id;
      } else {
        this.$notify({
          text: this.$t("maps.error_storing_marker"),
          type: "error",
        });
      }
    },
    async deleteMarker(marker) {
      const response = await axios.delete(`map/marker/${marker.id}`, {
        data: marker,
      });
      if (response.status === 200) {
        this.$notify({
          text: this.$t("maps.marker_deleted_successfully"),
          type: "success",
        });
      } else {
        this.$notify({
          text: this.$t("maps.error_deleting_marker"),
          type: "error",
        });
      }
      this.selected_marker = null;
      this.markers = this.markers.filter((m) => m.id !== marker.id);
    },
    async updateMarker(marker) {
      const response = await axios.put(`map/marker/${marker.id}`, marker);
      if (response.status === 200) {
        this.$notify({
          text: this.$t("maps.marker_updated_successfully"),
          type: "success",
        });
      } else {
        this.$notify({
          text: this.$t("maps.error_updating_marker"),
          type: "error",
        });
      }
      this.selected_marker = null;
      this.markers = this.markers.map((m) => {
        if (m.id === marker.id) {
          return { ...m, ...marker };
        }
        return m;
      });
    },
    async getMarkers() {
      this.loading = true;
      const response = await axios.get("map/markers");
      if (response.status === 200) {
        this.original_markers = response.data.data;
        this.original_markers.forEach((marker) => {
          marker.icon = L.divIcon({
            className: "custom-marker",
            html: `
            <div style="text-align:center;display: flex;flex-direction: column; align-items: center; justify-content: end;">
              <div style="font-size:12px; color:#333;width:65px;font-style:italic">${marker.name}</div>
              <div style="width:20px; height:20px; background:${marker.color}; border-radius:50%;"></div>
            </div>
          `,
            iconSize: [30, 40],
            iconAnchor: [15, 40],
          });
        });
        this.markers = [...this.original_markers];
      } else {
        console.error("Error fetching markers:", response.statusText);
      }

      this.loading = false;
    },
    async getAccounts() {
      this.loading = true;
      const response = await axios.get("map/accounts");
      if (response.status === 200) {
        this.original_accounts = response.data.data;
        this.original_accounts.forEach((account) => {
          account.icon = L.divIcon({
            className: "custom-marker",
            html: `
            <div style="text-align:center;display: flex; flex-direction:column; align-items: center; justify-content: end;position: relative">
              <div style="font-size:12px; color:#333;width:65px;position:absolute;top:0;z-index:2">${
                account.username
              }</div>
              <div style="width:20px; height:20px; background:${
                account.online ? "green" : "gray"
              }; border-radius:50%;position:absolute;top:0;z-index:1"></div>
            </div>
          `,
            iconSize: [30, 40],
            iconAnchor: [15, 40],
          });
        });
        this.accounts = [...this.original_accounts];
      } else {
        console.error("Error fetching accounts:", response.statusText);
      }
      this.loading = false;
    },
    async getNetworkDevices() {
      this.loading = true;
      const response = await axios.get("map/devices");
      if (response.status === 200) {
        this.original_network_devices = response.data.data;
        this.network_devices = [...this.original_network_devices];
      } else {
        console.error("Error fetching devices:", response.statusText);
      }
    },
    applyFilter() {
      if (this.filters.accounts === "online") {
        this.accounts = this.original_accounts.filter(
          (account) => account.online === true,
        );
      } else if (this.filters.accounts === "none") {
        this.accounts = this.original_accounts.filter(
          (account) => account.online === 12,
        );
      } else {
        this.accounts = [...this.original_accounts];
      }
      if (this.filters.markers === "none") {
        this.markers = [];
      } else {
        this.markers = [...this.original_markers];
      }
      if (this.filters.devices === "none") {
        this.network_devices = [];
      } else {
        this.network_devices = [...this.original_network_devices];
      }
    },
  },
};
</script>
